export default __webpack_public_path__ + "cbb79ed0d5d94efa5714eeb647e0d0c2.svg";